module.exports = __webpack_public_path__ + "static/icon_buyStep2-26692f669ad6cc57b2e55b4ca348658d.png";